import { render, staticRenderFns } from "./sAddModel.vue?vue&type=template&id=a2b291ec&scoped=true&"
import script from "./sAddModel.vue?vue&type=script&lang=js&"
export * from "./sAddModel.vue?vue&type=script&lang=js&"
import style0 from "./sAddModel.vue?vue&type=style&index=0&id=a2b291ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b291ec",
  null
  
)

export default component.exports